const config = {
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001',
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
  dailyDomain: process.env.REACT_APP_DAILY_DOMAIN,
  hostEmail: process.env.REACT_APP_HOST_EMAIL,
  calendlyUrl: process.env.REACT_APP_CALENDLY_URL,
  apiKey: 'ss_7b2e5d9f-a834-4c1d-b592-e8f6c3a45678'
};

export default config; 